export const UtcToLocalDateString = (utcDate: Date) => {
  return new Date(utcDate).toLocaleString()
}
